<div class="header">
  <span>
      <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </span>
  <div class="logout-container" *ngIf="identity || token">
      <span style="margin-right: 10px;"> <b>{{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}</b> </span>
      <button class="logout-btn" (click)="logout()">Cerrar Sesión</button>
  </div>
</div>


<div class="container" *ngIf="!buscando">

  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div mat-card-avatar class="example-header-image"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="title1b">Seguimiento de Certificados</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
          <p>Dirección de Obras Municipales</p>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="row">
        <form [formGroup]="search">
          <div class="rol-div">
            <h4 class="card-title">Rut</h4>
            <mat-form-field class="mat-field-rol">
              <input matInput type="text" placeholder="Rut" formControlName="rut">
              <button mat-button *ngIf="search.controls.rut.value" matSuffix mat-icon-button aria-label="Clear"
                (click)="search.controls.rut.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="rol-div">
            <h4 class="card-title">Número de Solicitud</h4>
            <mat-form-field class="mat-field-rol">
              <input matInput type="text" placeholder="Nº Solicitud" formControlName="numSol">
              <button mat-button *ngIf="search.controls.numSol.value" matSuffix mat-icon-button aria-label="Clear"
                (click)="search.controls.numSol.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

        </form>



        <!--
          <div class="rol-div">
            
            <h4 class="card-title">Fecha de ingreso</h4>
            <mat-form-field>
              <input matInput [matDatepicker]="picker" placeholder="Fecha" [formControl]="fecha_ingreso">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          -->

        <div class="btn-cont">
          <button color="primary" mat-raised-button (click)="get_certificado(numSol.value)"
            [disabled]="!search.controls.numSol.valid || !search.controls.rut.valid">Busqueda</button>
        </div>

      </div>

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>
</div>

<div class="container" *ngIf="buscando">

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" align="right">
      <p>
        <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
      </p>
    </div>

  </div>
  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div class="get-data-cont">

          <div class="title1b" align="center">Número de Solicitud : {{ certificado_info._Cer_NumeroX ?
            certificado_info._Cer_NumeroX : certificado_info._Cat_NumeroX }}</div>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="card-title">Fecha de ingreso:</label>
          <label class="parag">
            {{ fechaIngeso ? fechaIngeso : 'No hay
            información ingresada' }}

          </label>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="card-title">Solicitante:</label>
          <label class="parag">
            {{ certificado_info['Solicitante 2::Sol_Nombre_ Completo'] ?
            certificado_info['Solicitante 2::Sol_Nombre_ Completo'] : certificado_info['Solicitante::Sol_Nombre_
            Completo'] ? certificado_info['Solicitante::Sol_Nombre_ Completo'] : 'No hay información ingresada' }}
          </label>
        </div>
        <div class="tab_info col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <mat-tab-group>


            <mat-tab
              label="{{ certificado_info._Cer_Rol_Calculo ? certificado_info._Cer_Rol_Calculo : certificado_info['Propiedad::Pro_ROL'] ? certificado_info['Propiedad::Pro_ROL'] : 'No hay información ingresada' }} "
              style="font-weight: bold;">


              <div class="info-cont">

                <div class="row" style="margin-top: 15px;">
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Nombre Certificado:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ certificado_info.Cer_Tipo_Solicitud_Certificado ?
                      certificado_info.Cer_Tipo_Solicitud_Certificado :
                      certificado_info.Cat_Tipo_Solicitud_Certificado
                      ? certificado_info.Cat_Tipo_Solicitud_Certificado
                      : 'No hay información ingresada' }}
                    </p>
                  </div>
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Dirección:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ certificado_info['Propiedad::Pro_Direc_completa'] ?
                      certificado_info['Propiedad::Pro_Direc_completa'] :
                      'No hay información ingresada' }}
                    </p>
                  </div>

                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Estado:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ certificado_info['Cer_Estado_descripcion_WEB'] ? certificado_info['Cer_Estado_descripcion_WEB']
                      : certificado_info['Cat_Estado_descripcion_WEB'] ? certificado_info['Cat_Estado_descripcion_WEB']
                      : 'No hay información ingresada' }}
                    </p>
                  </div>
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Descarga:</p>
                  </div>
                  <div *ngIf="link" class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      <a [href]="link" target="_blank">Descargar</a>
                    </p>
                  </div>
                  <div *ngIf="!link" class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>No disponible
                    </p>
                  </div>
                </div>
                <hr>

              </div>

            </mat-tab>

          </mat-tab-group>
        </div>
      </div>

    </mat-card-header>
    <mat-card-content>
      <div class="row">

      </div>
    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>

</div>